import { Memorial, Company, Institution, SearchFilters } from './types';

// ---------- INSTITUTIONS ----------

export const mockInstitutions: Institution[] = [
  {
    id: 'inst-1',
    name: 'Gymnasium am Stadtpark',
    type: 'school',
    city: 'Düsseldorf',
    region: 'Nordrhein-Westfalen',
    country: 'Deutschland',
    memorialCount: 127,
  },
  {
    id: 'inst-2',
    name: 'Heinrich-Heine-Universität',
    type: 'university',
    city: 'Düsseldorf',
    region: 'Nordrhein-Westfalen',
    country: 'Deutschland',
    memorialCount: 89,
  },
  {
    id: 'inst-3',
    name: 'Stadtwerke Düsseldorf AG',
    type: 'company',
    city: 'Düsseldorf',
    region: 'Nordrhein-Westfalen',
    country: 'Deutschland',
    memorialCount: 45,
  },
  {
    id: 'inst-4',
    name: 'Schützenverein St. Sebastianus 1316 e.V.',
    type: 'club',
    city: 'Düsseldorf-Oberkassel',
    region: 'Nordrhein-Westfalen',
    country: 'Deutschland',
    memorialCount: 23,
  },
];

// ---------- COMPANY ----------

export const mockCompany: Company = {
  id: 'company-1',
  name: 'YANA Bestattung',
  slug: 'yana-bestattung',
  logoUrl: null,
  websiteUrl: 'https://yana-bestattung.de',
  phone: '+49 211 123456',
  email: 'info@yana-bestattung.de',
  address: 'Musterstraße 123, 40545 Düsseldorf',
  memorialPortalPrimaryColor: '#2C3E50',
  memorialPortalSecondaryColor: '#8B7355',
  memorialPortalBackgroundColor: '#FAFAF8',
  memorialPortalTextPrimaryColor: '#1A1A1A',
  memorialPortalTextSecondaryColor: '#6B7280',
  memorialPortalAccentColor: '#D4AF37',
};

// ---------- MAIN MEMORIAL ----------

export const mockMemorial: Memorial = {
  id: 'memorial-1',
  slug: 'hans-mueller-1942-2024',

  firstName: 'Hans',
  lastName: 'Müller',
  birthName: null,
  dateOfBirth: '1942-03-15',
  dateOfDeath: '2024-01-10',
  cityOfDeath: 'Düsseldorf',
  placeOfResidence: 'Düsseldorf-Oberkassel',

  placeOfBurial: 'Nordfriedhof Düsseldorf',
  placeOfService: 'St. Antonius Kirche, Oberkassel',
  addressOfBurial: 'Johannstraße 1, 40474 Düsseldorf',
  addressOfService: 'Luegallee 65, 40545 Düsseldorf',
  dateOfBurial: '2024-01-20',
  dateOfService: '2024-01-20',
  timeOfBurial: '14:00',
  timeOfService: '11:00',
  occasion1: 'Anschließend laden wir zur Kaffeetafel im Gemeindehaus ein.',
  occasion2: null,

  city: 'Düsseldorf',
  region: 'Nordrhein-Westfalen',
  postalCode: '40545',
  country: 'Deutschland',

  descriptions: `Hans Müller wurde am 15. März 1942 in Düsseldorf geboren und wuchs im Stadtteil Oberkassel auf. Nach seinem Abitur am Gymnasium am Stadtpark studierte er Betriebswirtschaft an der Heinrich-Heine-Universität.

Über 40 Jahre lang war er bei den Stadtwerken Düsseldorf tätig, wo er als Kaufmännischer Leiter großen Respekt genoss. Seine Kollegen schätzten ihn nicht nur für seine Fachkompetenz, sondern vor allem für seine Menschlichkeit und seinen feinen Humor.

Hans war ein liebevoller Ehemann, Vater und Großvater. Seine Familie war sein größter Stolz. Besonders gerne verbrachte er Zeit in seinem Garten, bei seinen geliebten Rosen, und beim Schützenverein St. Sebastianus, dessen Ehrenmitglied er seit 2010 war.

Er hinterlässt seine Frau Elisabeth, mit der er 52 Jahre verheiratet war, seine Kinder Michael und Susanne sowie vier Enkelkinder, die ihn liebevoll "Opa Hansi" nannten.

In unseren Herzen wird er weiterleben.`,
  notes: null,

  imagePath: 'https://images.unsplash.com/photo-1566616213894-2d4e1baee5d8?w=400&h=400&fit=crop',
  heroImagePath: 'https://images.unsplash.com/photo-1416879595882-3373a0480b5b?w=1920&h=600&fit=crop',

  companyId: 'company-1',
  company: mockCompany,
  publishToSite: true,

  // Life events with institution connections
  lifeEvents: [
    {
      id: 'le-1',
      memorialId: 'memorial-1',
      eventType: 'education',
      title: 'Grundschule am Belsenplatz',
      location: 'Düsseldorf-Oberkassel',
      yearStart: 1948,
      yearEnd: 1952,
      description: null,
      sortOrder: 1,
    },
    {
      id: 'le-2',
      memorialId: 'memorial-1',
      eventType: 'education',
      title: 'Gymnasium am Stadtpark',
      location: 'Düsseldorf',
      yearStart: 1952,
      yearEnd: 1961,
      description: 'Abitur 1961',
      institutionId: 'inst-1',
      sortOrder: 2,
    },
    {
      id: 'le-3',
      memorialId: 'memorial-1',
      eventType: 'education',
      title: 'Heinrich-Heine-Universität',
      location: 'Düsseldorf',
      yearStart: 1961,
      yearEnd: 1966,
      description: 'Diplom-Kaufmann',
      institutionId: 'inst-2',
      sortOrder: 3,
    },
    {
      id: 'le-4',
      memorialId: 'memorial-1',
      eventType: 'work',
      title: 'Stadtwerke Düsseldorf AG',
      location: 'Düsseldorf',
      yearStart: 1966,
      yearEnd: 2007,
      description: 'Kaufmännischer Leiter (1985-2007)',
      institutionId: 'inst-3',
      sortOrder: 4,
    },
    {
      id: 'le-5',
      memorialId: 'memorial-1',
      eventType: 'membership',
      title: 'Schützenverein St. Sebastianus',
      location: 'Düsseldorf-Oberkassel',
      yearStart: 1975,
      yearEnd: null,
      description: 'Ehrenmitglied seit 2010',
      institutionId: 'inst-4',
      sortOrder: 5,
    },
    {
      id: 'le-6',
      memorialId: 'memorial-1',
      eventType: 'milestone',
      title: 'Goldene Hochzeit',
      location: 'Düsseldorf',
      yearStart: 2022,
      yearEnd: 2022,
      description: 'Mit Elisabeth',
      sortOrder: 6,
    },
  ],

  // Institution connections (searchable)
  institutions: [
    {
      id: 'ic-1',
      memorialId: 'memorial-1',
      institutionId: 'inst-1',
      institution: mockInstitutions[0],
      yearStart: 1952,
      yearEnd: 1961,
      role: 'Schüler',
      graduationYear: 1961,
    },
    {
      id: 'ic-2',
      memorialId: 'memorial-1',
      institutionId: 'inst-2',
      institution: mockInstitutions[1],
      yearStart: 1961,
      yearEnd: 1966,
      role: 'Student',
      graduationYear: 1966,
      department: 'Wirtschaftswissenschaften',
    },
    {
      id: 'ic-3',
      memorialId: 'memorial-1',
      institutionId: 'inst-3',
      institution: mockInstitutions[2],
      yearStart: 1966,
      yearEnd: 2007,
      role: 'Kaufmännischer Leiter',
      department: 'Verwaltung',
    },
    {
      id: 'ic-4',
      memorialId: 'memorial-1',
      institutionId: 'inst-4',
      institution: mockInstitutions[3],
      yearStart: 1975,
      yearEnd: null,
      role: 'Ehrenmitglied',
    },
  ],

  // Family managers
  familyManagers: [
    {
      id: 'fm-1',
      memorialId: 'memorial-1',
      userId: 'user-1',
      user: {
        id: 'user-1',
        displayName: 'Elisabeth Müller',
        relationship: 'Ehefrau',
      },
      role: 'owner',
      canModerateCondolences: true,
      canUploadPhotos: true,
      canEditDetails: true,
      invitedAt: '2024-01-11T10:00:00Z',
      acceptedAt: '2024-01-11T10:05:00Z',
    },
    {
      id: 'fm-2',
      memorialId: 'memorial-1',
      userId: 'user-2',
      user: {
        id: 'user-2',
        displayName: 'Michael Müller',
        relationship: 'Sohn',
      },
      role: 'editor',
      canModerateCondolences: true,
      canUploadPhotos: true,
      canEditDetails: false,
      invitedAt: '2024-01-11T11:00:00Z',
      acceptedAt: '2024-01-11T12:00:00Z',
    },
  ],

  // Condolences
  condolenceComments: [
    {
      id: 'cond-1',
      descriptions: 'Liebe Familie Müller,\n\nwir sind tief betroffen vom Verlust von Hans. Er war ein wunderbarer Nachbar und Freund. Seine herzliche Art und sein ansteckendes Lachen werden uns sehr fehlen.\n\nIn Gedanken sind wir bei Ihnen.',
      firstName: 'Maria',
      lastName: 'Schmidt',
      isPublic: true,
      isApproved: true,
      createdAt: '2024-01-15T10:30:00Z',
      updatedAt: null,
      replyToCondolenceComments: [
        {
          id: 'reply-1',
          description: 'Liebe Maria, vielen Dank für Ihre liebevollen Worte. Hans hat oft von Ihnen und den schönen Nachbarschaftsgesprächen erzählt.',
          account: { id: 'user-1', firstName: 'Elisabeth', lastName: 'Müller', email: null },
          createdAt: '2024-01-15T14:00:00Z',
          updatedAt: null,
        },
      ],
    },
    {
      id: 'cond-2',
      descriptions: 'Hans war ein großartiger Kollege und Mentor. Seine Fachkompetenz und vor allem seine Menschlichkeit haben mich durch meine ersten Jahre bei den Stadtwerken begleitet. Mein aufrichtiges Beileid an die Familie.',
      firstName: 'Thomas',
      lastName: 'Weber',
      isPublic: true,
      isApproved: true,
      createdAt: '2024-01-14T16:45:00Z',
      updatedAt: null,
      replyToCondolenceComments: [],
    },
    {
      id: 'cond-3',
      descriptions: 'Ruhe in Frieden, lieber Onkel Hans. Du wirst immer in unseren Herzen bleiben. Deine Geschichten vom Schützenfest und dein Lachen werden mir fehlen.',
      firstName: 'Sabine',
      lastName: 'Müller-Braun',
      isPublic: true,
      isApproved: true,
      createdAt: '2024-01-14T09:15:00Z',
      updatedAt: null,
      replyToCondolenceComments: [],
    },
  ],

  // Memories (Stories)
  memories: [
    {
      id: 'mem-1',
      memorialId: 'memorial-1',
      authorName: 'Klaus Bergmann',
      relationship: 'Ehemaliger Kollege',
      title: 'Die Kaffeepause, die alles änderte',
      content: 'Als ich 1985 neu bei den Stadtwerken anfing, war ich völlig überfordert. Hans nahm mich eines Tages beiseite und sagte: "Klaus, komm mal mit zur Kaffeepause." In dieser halben Stunde erklärte er mir mehr über das Unternehmen als jedes Handbuch es je könnte. Ab diesem Tag war er mein Mentor und Freund.',
      isPublic: true,
      isApproved: true,
      createdAt: '2024-01-16T09:00:00Z',
    },
    {
      id: 'mem-2',
      memorialId: 'memorial-1',
      authorName: 'Helga Neumann',
      relationship: 'Nachbarin',
      title: 'Der Rosengärtner',
      content: 'Jeden Sommer stand Hans in seinem Garten und kümmerte sich liebevoll um seine Rosen. Einmal hat er mir einen ganzen Nachmittag lang erklärt, wie man die perfekte Rose züchtet. Seine Geduld und sein Wissen waren beeindruckend. Ich werde seinen blühenden Garten vermissen.',
      isPublic: true,
      isApproved: true,
      createdAt: '2024-01-17T14:30:00Z',
    },
  ],

  // Candles
  candles: [
    { id: 'candle-1', name: 'Familie Schmidt', description: 'In stillem Gedenken', email: null, image: null, createdAt: '2024-01-15T11:00:00Z' },
    { id: 'candle-2', name: 'Erika', description: 'Ruhe in Frieden', email: null, image: null, createdAt: '2024-01-15T09:30:00Z' },
    { id: 'candle-3', name: 'Schützenverein St. Sebastianus', description: 'Für unseren Kameraden', email: null, image: null, createdAt: '2024-01-14T20:00:00Z' },
    { id: 'candle-4', name: 'Anonym', description: null, email: null, image: null, createdAt: '2024-01-14T18:30:00Z' },
    { id: 'candle-5', name: 'Heinrich & Gisela', description: 'Du fehlst uns', email: null, image: null, createdAt: '2024-01-14T15:00:00Z' },
    { id: 'candle-6', name: 'Die Rosenzucht-Freunde', description: 'Für den besten Rosengärtner', email: null, image: null, createdAt: '2024-01-14T12:00:00Z' },
    { id: 'candle-7', name: 'Stadtwerke-Kollegen', description: 'In Erinnerung an einen großartigen Chef', email: null, image: null, createdAt: '2024-01-14T10:00:00Z' },
  ],

  // Gallery
  galleryImages: [
    { id: 'img-1', name: 'Goldene Hochzeit 2022', description: 'Mit Elisabeth bei der Feier', image: 'https://images.unsplash.com/photo-1511895426328-dc8714191300?w=800', isReleased: true, memorialPortalId: 'memorial-1', createdAt: '2024-01-14T10:00:00Z' },
    { id: 'img-2', name: 'Im geliebten Garten', description: 'Bei seinen Rosen', image: 'https://images.unsplash.com/photo-1416879595882-3373a0480b5b?w=800', isReleased: true, memorialPortalId: 'memorial-1', createdAt: '2024-01-14T10:05:00Z' },
    { id: 'img-3', name: 'Schützenfest 2015', description: 'Mit den Vereinskameraden', image: 'https://images.unsplash.com/photo-1529543544277-750e9f1f0a66?w=800', isReleased: true, memorialPortalId: 'memorial-1', createdAt: '2024-01-14T10:10:00Z' },
    { id: 'img-4', name: 'Familienurlaub Mallorca', description: 'Sommer 2019', image: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=800', isReleased: true, memorialPortalId: 'memorial-1', createdAt: '2024-01-14T10:15:00Z' },
    { id: 'img-5', name: 'Mit den Enkeln', description: 'Weihnachten 2023', image: 'https://images.unsplash.com/photo-1513475382585-d06e58bcb0e0?w=800', isReleased: true, memorialPortalId: 'memorial-1', createdAt: '2024-01-14T10:20:00Z' },
  ],
};

// Additional memorials for listing
export const mockMemorials: Memorial[] = [
  mockMemorial,
  {
    ...mockMemorial,
    id: 'memorial-2',
    slug: 'maria-schmidt-1938-2024',
    firstName: 'Maria',
    lastName: 'Schmidt',
    birthName: 'Becker',
    dateOfBirth: '1938-07-22',
    dateOfDeath: '2024-01-08',
    placeOfResidence: 'Düsseldorf-Bilk',
    imagePath: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=400&h=400&fit=crop',
    heroImagePath: null,
    descriptions: 'Maria Schmidt, geb. Becker, verstarb friedlich im Kreise ihrer Familie. Sie war eine liebevolle Mutter, Großmutter und Urgroßmutter, die ihr ganzes Leben der Familie widmete.\n\nIhre Güte und Herzlichkeit werden allen, die sie kannten, in Erinnerung bleiben.',
    condolenceComments: [],
    memories: [],
    lifeEvents: [],
    institutions: [],
    galleryImages: [],
    candles: [],
    familyManagers: [],
  },
  {
    ...mockMemorial,
    id: 'memorial-3',
    slug: 'wilhelm-braun-1945-2024',
    firstName: 'Wilhelm',
    lastName: 'Braun',
    birthName: null,
    dateOfBirth: '1945-11-03',
    dateOfDeath: '2024-01-05',
    placeOfResidence: 'Neuss',
    city: 'Neuss',
    imagePath: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop',
    heroImagePath: null,
    descriptions: 'In Liebe und Dankbarkeit nehmen wir Abschied von Wilhelm Braun. Ein Leben voller Güte und Wärme ist zu Ende gegangen.\n\nEr war ein treuer Ehemann, liebevoller Vater und stolzer Großvater. Seine Leidenschaft für Musik und Natur teilte er gerne mit seiner Familie.',
    condolenceComments: [],
    memories: [],
    lifeEvents: [],
    institutions: [],
    galleryImages: [],
    candles: [],
    familyManagers: [],
  },
];

// Helper functions
export function getMemorialBySlug(slug: string): Memorial | undefined {
  return mockMemorials.find(m => m.slug === slug);
}

export function searchMemorials(filters: SearchFilters): Memorial[] {
  let results = [...mockMemorials];

  if (filters.query) {
    const q = filters.query.toLowerCase();
    results = results.filter(m =>
      m.firstName?.toLowerCase().includes(q) ||
      m.lastName?.toLowerCase().includes(q) ||
      m.birthName?.toLowerCase().includes(q)
    );
  }

  if (filters.city) {
    results = results.filter(m => m.city?.toLowerCase().includes(filters.city!.toLowerCase()));
  }

  if (filters.institutionId) {
    results = results.filter(m =>
      m.institutions.some(i => i.institutionId === filters.institutionId)
    );
  }

  return results;
}

export function getInstitutionById(id: string): Institution | undefined {
  return mockInstitutions.find(i => i.id === id);
}
